import GpaCalculator from './GpaCalculator';

export default GpaCalculator;
